<div class="row">
  <div class="col-md-6">
    <div class="paginator-parent">
      <div class="paginator-page-size d-flex flex-direction-row align-items-center hght100">
        <div class="paginator-page-size-label hght100 d-flex align-items-center"> Items per page:</div>
        <div class=" d-flex align-items-center hght100">
          <div class="select">

            <select id="itemPerPage" name="itemPerPage" [(ngModel)]="itemPerPageSelectedValue"
              (change)="changeItemPerPage(itemPerPageSelectedValue)">
              <option *ngFor="let item of numberOfItemsPerPageOption" [ngValue]="item">
                {{item}}
              </option>
            </select>
          </div>
        </div>
        <div class="paginator-range-actions hght100 d-flex align-items-center pipe">
          <div class="paginator-range-label">
            <!-- {{((selectedPage * itemPerPageSelectedValue)- (itemPerPageSelectedValue ))+1}} –
            {{(selectedPage * itemPerPageSelectedValue)>totalLength?totalLength:(selectedPage * itemPerPageSelectedValue)}} -->
            {{backwardCount}} - {{forwardCount}}
            of {{totalLength}} items
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="paginator-page d-flex flex-direction-row align-items-center justify-content-end  paginator-parent">
      <div class=" d-flex align-items-center hght100 pipe">
        <div class="select right0">

          <select id="selectedPage" name="selectedPage" [(ngModel)]="selectedPage"
            (change)="changeSelectedPage(selectedPage)">
            <option *ngFor="let item of arrayOne(totalPages); let i = index;" [ngValue]="i+1">
              {{i+1}}
            </option>
          </select>
        </div>
      </div>
      <div class="paginator-range-actions d-flex align-items-center hght100">
        <div class="paginator-range-label">of {{totalPages}} pages</div>
        <div class="left arrow pipe" (click)="navigationButton('Backward')"></div>
        <div class="right arrow pipe" (click)="navigationButton('Forward')"></div>
      </div>
    </div>
  </div>
</div>
